import getImageRenditions from '../../../utils/getImageRenditions'
import getEpisodeUrl from '../../../utils/getEpisodeUrl'

async function getFeaturedShortform({ programmeGuid, playerApi }) {
  try {
    const { results } = await playerApi({
      path: '/shortform',
      query: {
        'programme.guid': programmeGuid,
        limit: 30,
        orderBy: '-availability.from',
        groupToken: '0071',
      },
    })
    // exclude autoplay hero previews
    const filteredResults = results.filter(result => !result.collection?.guid?.includes('autoplay'))
    return filteredResults.map(extractShortFormData)
  } catch (e) {
    return null
  }
}

function extractShortFormData(result) {
  const link = getEpisodeUrl({
    episodeId: result.id,
    programmeGuid: result?.programme?.guid,
    path: 'video',
  })

  return {
    wide: true,
    link,
    id: result.id,
    title: result.title,
    duration: result?.video?._duration,
    label: result?.collection?.name,
    image: getImageRenditions(
      result?.images?.[0]._filepath,
      ['225x127', '365x205', '460x259']
    ),
    programmeName: result.programme?.name,
    durationOverlay: true,
  }
}

export default getFeaturedShortform
